<template>
  <a-modal
    v-model="visible"
    :title="title"
    width="22cm"

    :maskClosable="false"
    footer="">
    <a-input-search
      type="text"
      :placeholder="$t('placeholder.pleaseInput')"
      style="width: 300px"
      v-model="inputText"
      @search="onSearch"
      autocomplete="off"
      enterButton />
    <br /><br />

    <vxe-grid
      ref="grid"
      border
      resizable
      show-overflowd
      highlight-current-row
      height="450"
      :loading="loading"
      :pager-config="tablePage"
      :data="tableData"
      :columns="tableColumn"
      :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
      @current-change="clickRow"
      @cell-dblclick="onclickRow"
    >
    </vxe-grid>
  </a-modal>
</template>

<script>
import { getTableDataByApi } from '@/api/admin'
import { findOne, post } from '@/api/Api'
import api from '@/api'

export default {
    name: 'DynamicModal',
    data() {
      return {
        visible: false,
        selectcol: [],
        inputText: '',
        selectedRowKeys: [],
        selectCustRecord: '',
        maskClosable: false,
        show: false,
        loading: false,
        tablePage: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0
        },
        tableData: [],
        validRules: null,
        tableColumn: [],
        query: {},
        queryTerms: {}
      }
    },
    props: {
      'title': {
        type: String,
        default: null
      },
      'parameter': {
        type: Object,
        default: null
      },
      'headers': {
        type: Object,
        default: null
      },
      'queryId': {
        type: String,
        default: null
      }
    },
    methods: {
      open() {
        this.visible = true
        const that = this
        that.loading = true
        findOne('queryFactory', { id: this.queryId }).then((body) => {
          this.query = body
          this.tableColumn = JSON.parse(body.columns)
          this.queryTerms = JSON.parse(body.queryTerms)
          let promise
          if (this.queryTerms.queryType === undefined ||
            this.queryTerms.queryType === '2'
          ) {
            promise = post(api.adminQuery, {}, that.parameter)
          } else {
            promise = getTableDataByApi(this.queryTerms.apiDesc.method,
              this.queryTerms.apiDesc.url,
              JSON.parse(this.queryTerms.apiDesc.headers),
              {}
            )
          }
          promise.then((body) => {
            that.loading = false
            that.tableData = body
            // for (var i = 0; i < this.tableData.length; i++){
            //   if (this.tableData[i]['available'] === true){
            //     this.tableData[i]['available'] = '是'
            //   } else { this.tableData[i]['available'] = '否' }
            // }
          })
        })
      },
      onSearch(value) {
        this.inputText = value.toLowerCase()
        if (this.inputText !== '') {
          var list = []
          this.tableData.filter((data) => {
            if (String(data['mnemonicCode']).toLowerCase().indexOf(this.inputText) > -1 || String(data['no']).toLowerCase().indexOf(this.inputText) > -1) {
              list.push(data)
            }
            this.tableData = list
            return this.dataCustomer
          })
        } else {
          return this.open()
        }
      },
      onclickRow() {
        if (this.selectCustRecord.length !== 0) {
          this.$emit('rowDblClick', this.selectCustRecord)
          this.visible = false
        } else {
          this.$message.warning($t('message.pleaseSelect'))
        }
      },
      clickRow() {
        this.selectCustRecord = this.$refs.grid.getCurrentRecord()
      },
      handleOk() {
        if (this.selectCustRecord.length !== 0) {
          this.$emit('rowDblClick', this.selectCustRecord)
          this.visible = false
        } else {
          this.$message.warning($t('message.pleaseSelect'))
        }
      },
      handleCancel() {
        this.visible = false
      },
      onSelectChange(selectedRowKeys) {
        console.log('selectedRowKeys changed: ', selectedRowKeys)
        this.selectedRowKeys = selectedRowKeys
      }
    }
  }
</script>

<style scoped>

</style>
